import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errormodule = {
    state: {
        error: '',
        mensaje: ''
    },
    getters: {
        getError: state => state.error,
        getErrorMensaje: state => state.mensaje
    },
    actions: {
        setError({ commit }, code) {
            commit('setError', code)
        },
        setErrorMensaje({ commit }, mensaje) {
            commit('setErrorMensaje', mensaje)
        },
        eraseError({ commit }) {
            commit('eraseError');
        },
        sendInfoAboutError({getters},info) {
            var time = new Date();


            let data;
            data = '----------------------------------------\n';
            data += `ERROR en ESIC\n`;
            data += 'Hora del error:\n' + time.toTimeString() + '\n';
            data += 'Usuario: ' + getid + '\n';
            data += 'Nombre: ' + getName + '\n';
            data += 'Token: ' + getToken + '\n';
            data += 'Mensaje:\n' + info.mensaje + '\n';
            data += '----------------------------------------';

            data = { "text": data };

            let url = 'https://hooks.slack.com/services/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';

            var xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.send(JSON.stringify(data));
        }
    },
    mutations: {
        setError(state, code) {
            state.error = code
        },
        setErrorMensaje(state, mensaje) {
            state.mensaje = mensaje
        },
        eraseError(state) {
            state.error = ''
            state.mensaje = ''
        }
    }
}

export default errormodule;



// WEBPACK FOOTER //
// ./src/store/errorModule.js